import TargetsConfig from "./TargetsConfig";

export default TargetsConfig;
